<!--
 * @Description: 东西方老师排行榜 -- PC端
 * @Author: xiuwen
 * @Date: 2024-12-27 14:21:38
 * @LastEditors: xiuwen
 * @LastEditTime: 2025-06-24 11:23:04
-->
<template>
	<section class="m-card">
		<img class="m-title" :src="type === 'dongfang' ? dongfangImg : tarotImg" alt="" />
		<ul class="m-list">
			<li
				v-for="(item, index) in data.slice(0, 3)"
				:key="index"
				class="m-list-item"
				@click="goTeacherDetail(item.teacher_id)"
			>
				<div class="m-list-item-left">
					<img class="icon" :src="rankImg[index]" alt="" />
					<img class="avatar" :src="item.avatar" alt="" />
				</div>
				<div class="m-list-item-right">
					<div class="info">
						<span class="nickname">{{ item.nickname }}</span>
						<span class="year">從業{{ item.year }}</span>
					</div>
					<div class="tag-box">
						<span v-for="(v, index) in item?.academic_sector.split(',')" :key="index" class="tag">{{
							v
						}}</span>
					</div>
				</div>
			</li>
		</ul>
	</section>
</template>

<script setup>
import { useRouter } from "vue-router";
import { logEvent } from "~/utils/firebase";
// 图片
import rank1 from "~/assets/images/pc/rank1.png";
import rank2 from "~/assets/images/pc/rank2.png";
import rank3 from "~/assets/images/pc/rank3.png";
import dongfangImg from "./images/dongfang.png";
import tarotImg from "./images/tarot.png";

const props = defineProps({
	data: {
		type: Array,
		default: () => [],
	},
	type: {
		type: String,
		default: "",
	},
});

const rankImg = [rank1, rank2, rank3];

const goTeacherDetail = id => {
	if (import.meta.client) {
		logEvent(props.type === "dongfang" ? "site_master_east" : "site_master_west");
	}
	navigateTo({
		path: `/seer/teacher-detail/${id}`,
	});
};
</script>

<style lang="scss" scoped>
.m-card {
	flex-shrink: 0;
	padding-bottom: 20px;
	width: 536px;
	background: #ffffff;
	border-radius: 16px;
	font-family: PingFang SC;
	overflow: hidden;

	.m-title {
		width: 536px;
		height: 108px;
	}

	.m-list {
		.m-list-item {
			display: flex;
			align-items: center;
			padding: 0 20px;
			margin-top: 28px;
			width: 536px;
			height: 120px;
			position: relative;
			cursor: pointer;

			.m-list-item-left {
				position: relative;

				.avatar {
					width: 120px;
					height: 120px;
					object-fit: cover;
					border-radius: 6px;
					background:
						linear-gradient(180deg, #d2af8e 0%, #faeee2 100%),
						linear-gradient(180deg, #000000 0%, rgba(0, 0, 0, 0) 100%);
				}

				.icon {
					width: 64px;
					height: 34px;
					position: absolute;
					top: 0;
					left: -14px;
					transform: translateY(-50%);
				}
			}

			.m-list-item-right {
				margin-left: 20px;
				display: flex;
				flex-direction: column;

				.info {
					display: flex;
					align-items: center;

					.nickname {
						margin-right: 8px;
						font-weight: 600;
						font-size: 32px;
						color: #333333;
					}

					.year {
						font-weight: 400;
						font-size: 24px;
						color: #666666;
					}
				}

				.tag-box {
					margin: 14px 0 12px;
					height: 38px;
					display: flex;
					flex-wrap: wrap;
					overflow: hidden;

					.tag {
						margin-right: 10px;
						padding: 4px 8px;
						font-size: 22px;
						color: #c78234;
						line-height: 26px;
						background: #fff7eb;
						border-radius: 7px 7px 7px 7px;
					}
				}
			}
		}
	}
}
</style>
